/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class governmentServerApiServer {
  private history = [];
  public img = '';
  previousUrl;
  private APIService = environment.serviceUrl;

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  //get all server list http://localhost:5001/api/server/getServerData?currentPage=1&pageSize=5&search=Goa&refId=61cd936c3fbdda00167a5b92
  getGovtServerList(currentPage, pageSize, search, refId): Observable<any> {
    return this.http.get(
      this.APIService +
        'stateServers/getAllStateServerList?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&search=' +
        search +
        '&userId=' +
        refId
    );
  }

  downloadGovtServerList(email): Observable<any> {
    return this.http.get(
      this.APIService + '/server/downloadAllServerDetails?email=' + email
    );
  }

  getGovtServerListRefId(id): Observable<any> {
    return this.http.get(
      this.APIService + 'stateServers/getStateServerDetails?id=' + id
    );
  }

  //http://localhost:5001/api/server/getServerDataByUId?id=6245614bdbefb60860e754e5&refId=61c01a241852f0001628794d
  getStateServerDetailsById(id): Observable<any> {
    return this.http.get(
      this.APIService + 'stateServers/getStateServerDetails?id=' + id
    );
  }

  getAllGovtServerList(): Observable<any> {
    return this.http.get(this.APIService + 'stateServers/getAllServerData');
  }

  //get single server detail
  getServerDetails(sid): Observable<any> {
    return this.http.get(
      this.APIService + '/server/getServerDataById?id=' + sid
    );
  }

  addServer(Payload): Observable<any> {
    return this.http.post(
      this.APIService + 'stateServers/saveStateServer',
      Payload
    );
  }

  //Update server
  updateServer(Payload): Observable<any> {
    return this.http.put(
      this.APIService + 'stateServers/updateStateServer',
      Payload
    );
  }

  //Delete Server
  deleteGovtServer(stateServerId, userId): Observable<any> {
    return this.http.delete(
      this.APIService +
        'stateServers/deleteStateServer?id=' +
        stateServerId +
        '&userId=' +
        userId
    );
  }

  saveStateFirmware(firmwareDto): Observable<any> {
    return this.http.post(
      this.APIService + 'stateServers/saveStateFirmware',
      firmwareDto
    );
  }

  deleteFirmware(firmwareId, stateId, firmwareType): Observable<any> {
    return this.http.delete(
      this.APIService +
        'stateServers/deleteStateFirmware?firmwareId=' +
        firmwareId +
        '&stateId=' +
        stateId +
        '&firmwareType=' +
        firmwareType
    );
  }
}
